import { useEffect, useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

import { MODALS } from "@/constants/modals"
import { useStore } from "@/zustand/store"
import { getEmbedUrl } from "@/utils/helpers"

export default function AdditionalMaterialPreview() {
  const additionalMaterialPreview = useStore(
    (state) => state.modalsStates[MODALS.lecture.previewAdditionalMaterial]
  )

  const memoizedPreview = useMemo(() => {
    return additionalMaterialPreview || { materials: [], index: 0 }
  }, [additionalMaterialPreview])

  const { materials = [], index: initialIndex = 0 } = memoizedPreview
  const [index, setIndex] = useState(initialIndex)

  useEffect(() => {
    setIndex(initialIndex)
  }, [initialIndex])

  const { t } = useTranslation()

  const currentVideo = materials[index]
  if (!currentVideo)
    return (
      <p className="text-danger">
        {t("noMessages.no")}
        {t("noMessages.materials")}
      </p>
    )

  const embed = getEmbedUrl(currentVideo.url)

  const handleChangeIndex = (newIndex: number) => {
    if (newIndex >= 0 && newIndex < materials.length) {
      setIndex(newIndex)
    }
  }

  return (
    <div className="">
      <div className="d-flex justify-content-between mb-3">
        <div className="d-flex align-items-center gap-3">
          <button
            className="btn btn-outline-primary"
            onClick={() => handleChangeIndex(index - 1)}
            disabled={index === 0}
          >
            ◀ {t("buttons.prev")}
          </button>

          <button
            className="btn btn-outline-primary"
            onClick={() => handleChangeIndex(index + 1)}
            disabled={index === materials.length - 1}
          >
            {t("buttons.next")} ▶
          </button>
        </div>
      </div>

      {embed ? (
        <div className="ratio ratio-16x9 mb-3">
          <iframe
            src={embed.url}
            title={embed?.type === "direct" ? "Article" : "Video Player"}
            allow="autoplay"
            allowFullScreen
            style={{ border: 0 }}
          />
        </div>
      ) : (
        <p className="text-danger">
          {t("additionalMaterialsPreview.errors.invalid")}
        </p>
      )}
    </div>
  )
}
